import { render, staticRenderFns } from "./addCouponCate.vue?vue&type=template&id=cd33e706&scoped=true&"
import script from "./addCouponCate.vue?vue&type=script&lang=js&"
export * from "./addCouponCate.vue?vue&type=script&lang=js&"
import style0 from "./addCouponCate.vue?vue&type=style&index=0&id=cd33e706&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd33e706",
  null
  
)

export default component.exports